import TransportCenterPage from '@/pages/transport/TransportCenterPage';
import TransportCenter from '@/pages/TransportCenter';

const transportRouter = () => [
  {
    path: 'center',
    element: <TransportCenterPage />,
  },
];

export default transportRouter;
